export const ACCESS_TOKEN_STORAGE_KEY = 'ums_access_token';
export const ACCESS_TOKEN_QUERY_PARAM = 'access_token';

const readTokenFromUrl = (paramName) => {
	return new URLSearchParams(window.location.search).get(paramName);
};

export const persistAccessToken = (token) => {
	if (!token) return;
	window.__umsAccessToken = token;
	try {
		sessionStorage.setItem(ACCESS_TOKEN_STORAGE_KEY, token);
	} catch (e) {
		// sessionStorage can be blocked when UMS runs inside a cross-site iframe.
	}
};

const removeAuthQueryParams = () => {
	const params = new URLSearchParams(window.location.search);
	params.delete(ACCESS_TOKEN_QUERY_PARAM);
	params.delete('refresh_token');
	const query = params.toString();
	const nextUrl =
		window.location.pathname + (query ? `?${query}` : '') + window.location.hash;
	window.history.replaceState({}, document.title, nextUrl);
};

/** Bootstrap access token from iframe URL. Refresh token stays in the parent app. */
export const captureAccessTokenFromUrl = () => {
	const token = readTokenFromUrl(ACCESS_TOKEN_QUERY_PARAM);
	const hadAuthParams =
		token || readTokenFromUrl('refresh_token');

	if (!hadAuthParams) return null;

	if (token) {
		persistAccessToken(token);
	}
	removeAuthQueryParams();

	return token;
};

export const getAccessToken = () => {
	if (window.__umsAccessToken) {
		return window.__umsAccessToken;
	}

	try {
		const stored = sessionStorage.getItem(ACCESS_TOKEN_STORAGE_KEY);
		if (stored) {
			window.__umsAccessToken = stored;
			return stored;
		}
	} catch (e) {
		// sessionStorage unavailable in partitioned iframe storage.
	}

	const fromUrl = readTokenFromUrl(ACCESS_TOKEN_QUERY_PARAM);
	if (fromUrl) {
		persistAccessToken(fromUrl);
		return fromUrl;
	}

	return null;
};

export const toBearerAuthorization = (token) => {
	if (!token) return null;
	return token.startsWith('Bearer ') ? token : `Bearer ${token}`;
};

export const getStoredBearerAuthorization = () => {
	return toBearerAuthorization(getAccessToken());
};

export const applyAuthToAxiosConfig = (config) => {
	const authorization = getStoredBearerAuthorization();
	if (!config.headers) {
		config.headers = {};
	}
	config.headers['Cache-Control'] = 'no-cache';
	if (authorization) {
		config.headers['Authorization'] = authorization;
	}
	return config;
};

export const clearAccessToken = () => {
	delete window.__umsAccessToken;
	try {
		sessionStorage.removeItem(ACCESS_TOKEN_STORAGE_KEY);
	} catch (e) {
		// ignore
	}
};
